import React, { useRef } from "react";
import classNames from "classnames";

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:border b-black";

const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const inputErrorClass = "border border-red-500 b-2 text-red-500";

const AddOrganisationForm = ({
  formState,
  debouncedGetOrganisation,
  methods,
}) => {
  const { register, errors } = methods;
  const { gstError, panError } = formState;

  const handleInputChange = (e) => {
    const input = e.target.name;
    if (input === "panNumber") {
      // console.log("doit");
      debouncedGetOrganisation("pan", e.target.value);
    } else {
      debouncedGetOrganisation("gst", e.target.value);
    }
  };

  return (
    <div>
      <div className="md:flex">
        <div className="md:w-1/2 w-full mb-6">
          <label className={labelClass} htmlFor="gstNumber">
            GSTIN Number
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: gstError,
            })}
            id="gstNumber"
            placeholder="GST Number (ALL CAPS)"
            name="gstNumber"
            ref={register}
            onChange={handleInputChange}
          />
          {gstError && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{gstError}</span>
            </div>
          )}
        </div>

        <div className="md:w-1/2 w-full mb-6 md:ml-6">
          <label className={labelClass} htmlFor="panNumber">
            PAN Number
          </label>
          <input
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: panError,
            })}
            id="panNumber"
            placeholder="PAN Number"
            name="panNumber"
            ref={register}
            onChange={handleInputChange}
          />
          {panError && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{panError}</span>
            </div>
          )}
        </div>
      </div>

      {/* Same line inputs */}

      <>
        <div className="md:flex">
          <div className="md:w-1/2 w-full mb-6">
            <label
              className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
              htmlFor="org-name"
            >
              Registered Organisation Name
            </label>
            <input
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: errors?.registeredCompanyName?.message,
              })}
              id="org-name"
              name="registeredCompanyName"
              ref={register}
              placeholder="Registered Organisation Name"
            />
            {errors?.registeredCompanyName?.message && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.registeredCompanyName.message}</span>
              </div>
            )}
          </div>
          <div className="md:w-1/2 w-full mb-6 md:ml-6">
            <label className={labelClass} htmlFor="landline-num">
              Primary Landline Number
            </label>
            <input
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: errors?.landLineNumber?.message,
              })}
              id="landline-num"
              placeholder="Primary Landline"
            />
            {errors?.landLineNumber?.message && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.landLineNumber.message}</span>
              </div>
            )}
          </div>
        </div>
        <div className="w-full mb-6">
          <label className={labelClass} htmlFor="company-address">
            Registered Company Address
          </label>
          <textarea
            className={classNames({
              [inputClass]: true,
              [inputErrorClass]: errors?.registeredAddress?.message,
              "h-32": true,
            })}
            id="company-address"
            ref={register}
            name="registeredAddress"
            placeholder="Registered Company Address"
          ></textarea>
          {errors?.registeredAddress?.message && (
            <div className="text-xs text-red-500 flex flex-row-reverse">
              <span>{errors.registeredAddress.message}</span>
            </div>
          )}
        </div>
        {/* Same line inputs */}
        <div className="md:flex">
          <div className="md:w-1/2 w-full mb-6">
            <label className={labelClass} htmlFor="email-id">
              Registered Email ID
            </label>
            <input
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: errors?.registeredEmail?.message,
              })}
              id="email-id"
              ref={register}
              name="registeredEmail"
              placeholder="Email ID"
            />
            {errors?.registeredEmail?.message && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.registeredEmail.message}</span>
              </div>
            )}
          </div>
          <div className="md:w-1/2 w-full mb-6 md:ml-6">
            <label className={labelClass} htmlFor="phone-number">
              Phone Number
            </label>
            <input
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: errors?.phoneNumber?.message,
              })}
              id="phone-number"
              ref={register}
              name="phoneNumber"
              placeholder="Phone Number"
            />
            {errors?.phoneNumber?.message && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.phoneNumber.message}</span>
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default React.memo(AddOrganisationForm);
